import React, { useEffect, useState } from 'react';
import {
	BringzzPageContainer,
	BringzzIcon,
	BringzzText,
	BringzzTabs,
	BringzzTab,
	BringzzTabPanel,
	BringzzImage,
	BringzzGallery,
	BringzzBottomDrawer,
	BringzzRadioList,
	BringzzRadio,
	BringzzInput,
	BringzzButton,
	BringzzModal
} from '@bringzz/components';
import { useNavigation } from 'context/NavigationContext';
import { useLocation } from 'react-router-dom';
import useRequest from 'hooks/useRequest';
import { useAuth } from 'context/AuthContext';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import CollectionCreationDrawer from "./CollectionCreationDrawer";
import DefaultProductImage from 'assets/DefaultProductImage.png';
import LetterAvatar from '../../Pharmacy/Profile/components/LetterAvatar';
function useQuery() {
	return new URLSearchParams(useLocation().search);
}
let state = {
	checked: <div></div>,
	unChecked: <div></div>
};
const BookMarksCollection = () => {
	const { t } = useTranslation();
	const { backPress, navigate } = useNavigation();
	let query = useQuery();
	let collectionIntegrationId = query.get('id');
	let activeTab = query.get('tab') || 'posts';

	const { sendRequest, loading } = useRequest();

	const [openDrawer, setOpenDrawer] = useState(false);
	const [addCollectionOpen, setAddCollectionOpen] = useState(false);
	const [newCollectionName, setNewCollectionName] = useState('');
	const [modalOpen, setModalOpen] = useState(false);
	const [bottomDrawerType, setBottomDrawerType] = useState(null);
	const [selectedCollection, setSelectedCollection] = useState();
	const [collectionUpdate, setCollectionUpdate] = useState(false);
	const [collectionBookmarks, setCollectionBookmarks] = useState([]);
	const { user } = useAuth();

	const fetchCollection = async () => {
		try {
			const [collectionRes, bookmarksRes] = await Promise.all([
				sendRequest({
					method: 'POST',
					url: `/module/bookmarkcollection/getCollection`,
					data: { collectionIntegrationId }
				}),
				sendRequest({
					method: 'GET',
					url: `/module/bookmark/getAllBookmarks`
				})
			]);
			
			if (collectionRes.status === 'success') {
				setSelectedCollection(collectionRes.data[0]);
			}
			
			if (bookmarksRes.status === 'success') {
				// Filter bookmarks that belong to this collection
				const allBookmarks = bookmarksRes.data || [];
				const filteredBookmarks = allBookmarks.filter(bookmark => 
					bookmark.collectionUUID === collectionRes.data[0]?.integrationId
				);
				setCollectionBookmarks(filteredBookmarks);
			}
		} catch (error) {
			console.error('Error fetching collection:', error);
			toast.error('Failed to load collection');
		}
	};

	useEffect(() => {
		fetchCollection()
	}, [collectionUpdate])

	return (
		selectedCollection && (
			<BringzzPageContainer
				header={{
					left: (
						<BringzzIcon
							size='22'
							icon='IconChevronLeft'
							folder='LineIcons'
							className='cursor-pointer'
							onClick={backPress}
						/>
					),
					right: (
						<div className='flex flex-row space-x-4'>
							<BringzzIcon
								size='22'
								icon='IconMore'
								folder='LineIcons'
								className='rotate-90 cursor-pointer'
								onClick={async () => {
									setOpenDrawer(true);
								}}
							/>
						</div>
					),
					title: <BringzzText tag='h2'>{selectedCollection.name}</BringzzText>
				}}
			>
				<div className='p-4 space-y-4'>
					<BringzzTabs defaultActiveTab={activeTab}>
						{/* Posts Tab */}
						<BringzzTab id='posts'>
							<div className="flex items-center">
								<BringzzIcon icon="IconLayoutAlt" folder="LineIcons" size="20" className="mr-2" />
								<BringzzText tag='h4' className='font-bold'>
									{t('component.bookmarks.tabs.posts')} ({collectionBookmarks.filter(b => b.type == 0).length})
								</BringzzText>
							</div>
						</BringzzTab>
						<BringzzTabPanel id='posts'>
							{collectionBookmarks.filter(b => b.type == 0).length === 0 ? (
								<div className="flex flex-col items-center justify-center p-8 text-center">
									<BringzzIcon
										size="48"
										icon="IconLayoutAlt"
										folder="LineIcons"
										className="text-gray-400 mb-4"
									/>
									<BringzzText className="text-gray-600 mb-2">
										{t('component.bookmarks.empty_states.no_posts_collection')}
									</BringzzText>
								</div>
							) : (
								<div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
									{collectionBookmarks.filter(b => b.type == 0).map((bookmark) => (
										<div
											key={bookmark.id}
											className='bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300'
										>
											<div className='p-4 relative'>
												<BringzzIcon
													icon="IconBookmarkSolid"
													folder="HeroIcons"
													size="20"
													className="absolute top-2 right-2 text-purple-500 cursor-pointer hover:text-red-600 transition-colors"
													onClick={async () => {
														try {
															const response = await sendRequest({
																method: 'POST',
																url: '/module/bookmark/removeBookmark',
																data: { elementUUID: bookmark.elementUUID, type: 0 }
															});
															if (response.status === 'success') {
																setCollectionUpdate(prev => !prev);
																toast.success(t('component.bookmarks.messages.post_bookmark_removed'));
															}
														} catch (error) {
															toast.error(t('component.bookmarks.messages.failed_remove_bookmark'));
														}
													}}
												/>
												{bookmark.post_details?.length > 0 ? (
													<>
														<BringzzText tag='h4' className='text-lg font-semibold mb-2 pr-8'>
															{bookmark.post_details[0].headline}
														</BringzzText>
														<BringzzText tag='p' className='text-gray-600 mb-4 line-clamp-3'>
															{bookmark.post_details[0].description}
														</BringzzText>
													</>
												) : (
													<BringzzText tag='h4' className='text-lg font-semibold mb-2 pr-8'>
														{t('component.bookmarks.labels.saved_post')}
													</BringzzText>
												)}
											</div>
											<div className='border-t px-4 py-3 bg-gray-50'>
												<BringzzButton
													size='sm'
													className='w-full flex items-center justify-center'
													onClick={() => navigate(`/post/details/${bookmark.elementUUID}`)}
												>
													<BringzzIcon
														icon='IconExternalLink'
														folder='LineIcons'
														className='mr-2'
														size='16'
													/>
													{t('component.bookmarks.actions.view_post')}
												</BringzzButton>
											</div>
										</div>
									))}
								</div>
							)}
						</BringzzTabPanel>

						{/* Products Tab */}
						<BringzzTab id='products'>
							<div className="flex items-center">
								<BringzzIcon icon="IconSearch" folder="LineIcons" size="20" className="mr-2" />
								<BringzzText tag='h4' className='font-bold'>
									{t('component.bookmarks.tabs.products')} ({collectionBookmarks.filter(b => b.type == 1).length})
								</BringzzText>
							</div>
						</BringzzTab>
						<BringzzTabPanel id='products'>
							{collectionBookmarks.filter(b => b.type == 1).length === 0 ? (
								<div className="flex flex-col items-center justify-center p-8 text-center">
									<BringzzIcon
										size="48"
										icon="IconSearch"
										folder="LineIcons"
										className="text-gray-400 mb-4"
									/>
									<BringzzText className="text-gray-600 mb-2">
										{t('component.bookmarks.empty_states.no_products_collection')}
									</BringzzText>
								</div>
							) : (
								<div className='grid grid-cols-2 md:grid-cols-3 gap-4'>
									{collectionBookmarks.filter(b => b.type == 1).map((bookmark) => (
										<div
											key={bookmark.id}
											className='bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300'
										>
											<div className='p-4 relative'>
												<BringzzIcon
													icon="IconBookmarkSolid"
													folder="HeroIcons"
													size="20"
													className="absolute top-2 right-2 text-purple-500 cursor-pointer hover:text-red-600 transition-colors z-10"
													onClick={async () => {
														try {
															const response = await sendRequest({
																method: 'POST',
																url: '/module/bookmark/removeBookmark',
																data: { elementUUID: bookmark.elementUUID, type: 1 }
															});
															if (response.status === 'success') {
																setCollectionUpdate(prev => !prev);
																toast.success(t('component.bookmarks.messages.product_bookmark_removed'));
															}
														} catch (error) {
															toast.error(t('component.bookmarks.messages.failed_remove_bookmark'));
														}
													}}
												/>
												{bookmark.productInfo ? (
													<>
														<img 
															src={bookmark.productInfo.productImage && !bookmark.productInfo.productImage.endsWith('.pdf') ? bookmark.productInfo.productImage : DefaultProductImage} 
															alt={bookmark.productInfo.name}
															className={`w-full mb-3 rounded ${bookmark.productInfo.productImage && !bookmark.productInfo.productImage.endsWith('.pdf') ? 'h-32 object-cover' : 'h-20 object-contain'}`}
															onError={(e) => {
																e.target.src = DefaultProductImage;
																e.target.className = e.target.className.replace('h-32 object-cover', 'h-20 object-contain');
															}}
														/>
														<BringzzText tag='h4' className='text-sm font-semibold mb-2 line-clamp-2'>
															{bookmark.productInfo.name || 'Product'}
														</BringzzText>
														<BringzzText tag='p' className='text-green-600 font-bold mb-2'>
															€{bookmark.productInfo.price || '0.00'}
														</BringzzText>
													</>
												) : (
													<BringzzText tag='h4' className='text-lg font-semibold mb-2'>
														{t('component.bookmarks.labels.saved_product')}
													</BringzzText>
												)}
											</div>
											<div className='border-t px-4 py-3 bg-gray-50'>
												<BringzzButton
													size='sm'
													className='w-full flex items-center justify-center'
													onClick={() => navigate(`/product/details/${bookmark.productInfo?.integrationId || bookmark.elementUUID}`)}
												>
													<BringzzIcon
														icon='IconExternalLink'
														folder='LineIcons'
														className='mr-2'
														size='16'
													/>
													{t('component.bookmarks.actions.view_product')}
												</BringzzButton>
											</div>
										</div>
									))}
								</div>
							)}
						</BringzzTabPanel>
						
						{/* Pharmacies Tab */}
						<BringzzTab id='pharmacies'>
							<div className="flex items-center">
								<BringzzIcon icon="IconPharmacy" folder="HealthIcons" size="20" className="mr-2" />
								<BringzzText tag='h4' className='font-bold'>
									{t('component.bookmarks.tabs.pharmacies')} ({collectionBookmarks.filter(b => b.type == 2).length})
								</BringzzText>
							</div>
						</BringzzTab>
						<BringzzTabPanel id='pharmacies'>
							{collectionBookmarks.filter(b => b.type == 2).length === 0 ? (
								<div className="flex flex-col items-center justify-center p-8 text-center">
									<BringzzIcon
										size="48"
										icon="IconMedicalCross"
										folder="LineIcons"
										className="text-gray-400 mb-4"
									/>
									<BringzzText className="text-gray-600 mb-2">
										{t('component.bookmarks.empty_states.no_pharmacies_collection')}
									</BringzzText>
								</div>
							) : (
								<div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
									{collectionBookmarks.filter(b => b.type == 2).map((bookmark) => (
										<div
											key={bookmark.id}
											className='bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300'
										>
											<div className='p-4 relative'>
												<BringzzIcon
													icon="IconBookmarkSolid"
													folder="HeroIcons"
													size="20"
													className="absolute top-2 right-2 text-purple-500 cursor-pointer hover:text-red-600 transition-colors"
													onClick={async () => {
														try {
															const response = await sendRequest({
																method: 'POST',
																url: '/module/bookmark/removeBookmark',
																data: { elementUUID: bookmark.elementUUID, type: 2 }
															});
															if (response.status === 'success') {
																setCollectionUpdate(prev => !prev);
																toast.success(t('component.bookmarks.messages.pharmacy_bookmark_removed'));
															}
														} catch (error) {
															toast.error(t('component.bookmarks.messages.failed_remove_bookmark'));
														}
													}}
												/>
												<div className="flex items-center mb-3">
													{bookmark.pharmacy_details?.pharmacyPic ? (
														<img 
															src={bookmark.pharmacy_details.pharmacyPic} 
															alt={bookmark.pharmacy_details.name}
															className="w-12 h-12 rounded-full object-cover mr-3"
														/>
													) : (
														<LetterAvatar 
															name={bookmark.pharmacy_details?.name || 'Pharmacy'} 
															size="w-12 h-12"
															fontSize="text-sm"
															className="mr-3"
														/>
													)}
													<div>
														<BringzzText tag='h4' className='text-lg font-semibold'>
															{bookmark.pharmacy_details?.name || t('component.bookmarks.labels.pharmacy')}
														</BringzzText>
														<BringzzText className='text-gray-500 text-sm'>
															Saved {bookmark.created || t('component.bookmarks.labels.saved_recently')}
														</BringzzText>
													</div>
												</div>
											</div>
											<div className='border-t px-4 py-3 bg-gray-50'>
												<BringzzButton
													size='sm'
													className='w-full flex items-center justify-center'
													onClick={() => navigate(`/pharmacy/profile/${bookmark.elementUUID}`)}
												>
													<BringzzIcon
														icon='IconExternalLink'
														folder='LineIcons'
														className='mr-2'
														size='16'
													/>
													{t('component.bookmarks.actions.view_pharmacy')}
												</BringzzButton>
											</div>
										</div>
									))}
								</div>
							)}
						</BringzzTabPanel>
					</BringzzTabs>
					<BringzzBottomDrawer
						isOpen={openDrawer}
						close={() => setOpenDrawer(false)}
						title={t('component.bookmarks.actions.manage_collection')}
					>
						<div className='px-6 py-6'>
							<BringzzRadioList
								state={state}
								className='rounded-xl w-full text-center'
							>
								<BringzzRadio
									value='Male'
									className='p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400 flex'
								>
									<div
										onClick={() => {
											setBottomDrawerType('rename');
											setOpenDrawer(false);
											setAddCollectionOpen(true);
										}}
										className='w-full text-start'
									>
										{t('component.bookmarks.actions.rename')}
									</div>
								</BringzzRadio>
								<BringzzRadio
									value='Female'
									className='p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400'
								>
									<div
										onClick={() => {
											setOpenDrawer(false);
											setModalOpen(true);
										}}
										className='w-full text-start text-bold'
									>
										{t('common.delete')}
									</div>
								</BringzzRadio>
								<BringzzRadio
									className='p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400'
									value='Diverse'
								>
									<div 
										className='w-full text-start'
										onClick={async () => {
											console.log('Share clicked!');
											console.log('Selected collection:', selectedCollection);
											const collectionUrl = `${window.location.origin}/settings/bookmarks/collection?id=${selectedCollection.integrationId}`;
											console.log('Collection URL:', collectionUrl);
											navigator.clipboard.writeText(collectionUrl);
											toast.success(t('component.bookmarks.messages.collection_link_copied'));
											setOpenDrawer(false);
										}}
									>
										{t('component.bookmarks.actions.share')}
									</div>
								</BringzzRadio>
							</BringzzRadioList>
						</div>
					</BringzzBottomDrawer>
					<CollectionCreationDrawer
						addCollectionOpen={addCollectionOpen}
						setAddCollectionOpen={setAddCollectionOpen}
						bottomDrawerType={bottomDrawerType}
						selectedCollection={selectedCollection}
						newCollectionName={newCollectionName}
						setNewCollectionName={setNewCollectionName}
					/>
					{modalOpen && (
						<BringzzModal
							title={t('component.bookmarks.collections.delete.title')}
							description={t('component.bookmarks.collections.delete.description', { name: selectedCollection.name })}
							onCancel={() => setModalOpen(false)}
							onConfirm={async () => {
								try {
									const response = await sendRequest({
										method: 'DELETE',
										url: `/module/bookmarkcollection/deleteCollection`,
										data: {
											collectionId: selectedCollection.id
										}
									});
									if (response.status === 'success') {
										setModalOpen(false);
										toast.success(t('component.bookmarks.messages.collection_deleted'));
										backPress();
									} else {
										toast.error(t('component.bookmarks.messages.failed_delete_collection'));
									}
								} catch (error) {
									console.error('Error deleting collection:', error);
									toast.error(t('component.bookmarks.messages.failed_delete_collection'));
								}
							}}
							confirmButtonText={t('common.delete')}
						/>
					)}
				</div>
			</BringzzPageContainer>
		)
	);
};

export default BookMarksCollection;
